import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { useRef, useEffect, useState } from 'react';

import Menu from 'components/menu';
import IconButton from 'components/icon-button';
import Button, { ButtonProps } from 'components/button';

import useBoundStore from 'store';

import caretLeft from 'assets/images/caret-left.svg';
import styles from './styles.module.scss';

export type BaseScreenProps = {
  title?: string;
  controls?: React.ReactNode;
  children: React.ReactNode;
  buttons?: ButtonProps[];
  className?: string;
  headerClassName?: string;
  footerClassName?: string;
  fixedContentHeight?: boolean;
  floatingButtons?: boolean;
  noMarginForFloatingButtons?: boolean;
  padContent?: boolean;
  buttonPaddingLess?: boolean;
  error?: string;
  floatingButtonsAppear?: boolean;
  onBackButtonClick?: () => void;
  hideBackButton?: boolean;
};

const headerHeight = parseInt(styles.headerHeight);

const BaseScreen: React.FC<BaseScreenProps> = (props) => {
  const {
    title,
    controls,
    buttons,
    floatingButtons = true,
    noMarginForFloatingButtons,
    children,
    className,
    headerClassName,
    footerClassName,
    fixedContentHeight,
    buttonPaddingLess,
    padContent,
    error,
    floatingButtonsAppear,
    onBackButtonClick,
    hideBackButton,
  } = props;

  const navigate = useNavigate();

  const screenPadding = useBoundStore((s) => s.screenPadding);
  const setScreenPadding = useBoundStore((s) => s.setScreenPadding);

  const footerRef = useRef<HTMLElement>(null);
  const [footerHeight, setFooterHeight] = useState(0);

  useEffect(() => {
    if (floatingButtons && footerRef.current) {
      setFooterHeight(footerRef.current.scrollHeight);
      setScreenPadding(footerRef.current.scrollHeight + headerHeight);
    }
  }, [floatingButtons, buttons, noMarginForFloatingButtons, setScreenPadding]);

  const handleBack = () => {
    if (onBackButtonClick) {
      onBackButtonClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <main className={clsx(styles.container, className)}>
      <header className={clsx(styles.header, headerClassName)}>
        <div>
          <Menu />
          {!hideBackButton && <IconButton icon={caretLeft} onClick={handleBack} />}
        </div>
        <h1 className={styles.title}>{title}</h1>
        <div>{controls}</div>
      </header>

      <section
        style={{
          marginBottom: noMarginForFloatingButtons ? 0 : footerHeight,
          height: fixedContentHeight ? `calc(100vh - ${screenPadding}px)` : undefined,
        }}
        className={clsx(styles.content, padContent && styles.contentWithPadding)}
      >
        {children}
      </section>

      {buttons && (
        <footer
          ref={footerRef}
          className={clsx(
            styles.buttons,
            floatingButtons && styles.floatingButtons,
            floatingButtonsAppear && styles.floatingButtons_disappear,
            buttonPaddingLess && styles.buttons_paddingLess,
            footerClassName,
          )}
        >
          {error && (
            <div className={styles.errors}>
              <span>Проверьте форму: </span>
              <span className='text-error'>{error}</span>
            </div>
          )}
          {buttons.map((props, i) => (
            <Button key={i} {...props} />
          ))}
        </footer>
      )}
    </main>
  );
};

export const BASE_SCREEN_HEADER_HEIGHT = styles.headerHeight;

export default BaseScreen;
